import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../nav_bar/Navbar";
import Footer from "../footer/Footer";
import "./StudyHub.css";

const studyModules = [
  {
    title: "Vocabulary",
    description: "Learn new words, synonyms, antonyms and usage examples.",
    emoji: "📖",
    path: "/study/vocabulary",
    available: true,
  },
  {
    title: "Tongue Twisters",
    description: "Practice tricky phrases to improve pronunciation and fluency.",
    emoji: "👅",
    path: "/study/tongue-twisters",
    available: true,
  },
  {
    title: "Quick Boost",
    description: "Short video lessons to quickly level up your English.",
    emoji: "⚡",
    path: "/study/quick-boost",
    available: true,
  },
  {
    title: "Grammar",
    description: "Master English grammar rules with clear explanations.",
    emoji: "✏️",
    path: "/study/grammar",
    available: true,
  },
  {
    title: "Daily Sentences",
    description: "Practice everyday English sentences for real-life conversations.",
    emoji: "💬",
    path: "/study/daily-sentences",
    available: true,
  },
  {
    title: "Official Sentences",
    description: "Professional English for workplace and formal situations.",
    emoji: "🏢",
    path: "/study/official-sentences",
    available: true,
  },
  {
    title: "Similar Words",
    description: "Master commonly confused words and homophones.",
    emoji: "🔤",
    path: "/study/similar-words",
    available: true,
  },
  {
    title: "IPA Symbols",
    description: "Learn the International Phonetic Alphabet sounds.",
    emoji: "🗣️",
    path: "/study/ipa/symbols",
    available: true,
  },
  {
    title: "IPA Lessons",
    description: "Structured lessons to master English pronunciation.",
    emoji: "🎓",
    path: "/study/ipa/lessons",
    available: true,
  },
  {
    title: "Pronunciation",
    description: "Improve your accent and speaking clarity.",
    emoji: "🎙️",
    path: "/study/pronunciation",
    available: false,
  },
  {
    title: "Idioms & Phrases",
    description: "Understand common idioms used in daily conversations.",
    emoji: "💬",
    path: "/study/idioms",
    available: false,
  },
  {
    title: "Reading",
    description: "Practice reading comprehension with curated articles.",
    emoji: "📰",
    path: "/study/reading",
    available: false,
  },
  {
    title: "Listening",
    description: "Sharpen your listening skills with audio exercises.",
    emoji: "🎧",
    path: "/study/listening",
    available: false,
  },
];

const StudyHub = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <div className="study-hub">
        <h1 className="study-hub-title">📚 Study</h1>
        <p className="study-hub-subtitle">
          Choose a module and start learning at your own pace.
        </p>

        <div className="study-grid">
          {studyModules.map((mod) => (
            <div
              key={mod.title}
              className={`study-card ${!mod.available ? "coming-soon" : ""}`}
              onClick={() => mod.available && navigate(mod.path)}
            >
              <span className="study-card-emoji">{mod.emoji}</span>
              <h3 className="study-card-title">{mod.title}</h3>
              <p className="study-card-desc">{mod.description}</p>
              {!mod.available && (
                <span className="study-card-badge">Coming Soon</span>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default StudyHub;
